const targetNode = document.querySelector('#ProductPrice');
const config = { attributes: true, childList: true, subtree: true };

const callback = (mutationList, observer) => {
  // eslint-disable-next-line
  for (const mutation of mutationList) {
    if (mutation.type === 'childList') {
      // console.log("A child node has been added or removed.");
      const productPriceElement = document.querySelector('#ProductPrice .money');
      const currentCurrency = productPriceElement.dataset.currency;

      const element = document.querySelector('.weight-price');
      if (!element) return;
      const { productWeight } = element.dataset;

      let finalPrice;
      if (currentCurrency === 'PLN') {
        const currentPrice = parseFloat(productPriceElement.textContent.replace(' zł', '').replace(',', '.'));
        const priceForWeight = (currentPrice / productWeight) * 100;
        finalPrice = new Intl.NumberFormat('pl-PL', { style: 'currency', currency: 'PLN' }).format(priceForWeight);
      } else if (currentCurrency === 'EUR') {
        const currentPrice = parseFloat(productPriceElement.textContent.replace('€', ''));
        const priceForWeight = (currentPrice / productWeight) * 100;
        finalPrice = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(priceForWeight);
      }
      element.textContent = finalPrice;
    }
  }
};

const observer = new MutationObserver(callback);
observer.observe(targetNode, config);
